const mutations = {
  setConfigs(state, payload) {
    state.config = payload
  },
  setCashierVersion(state, version) {
    state.cashierVersion = version
  },
  setCashierBaseUrl(state, url) {
    state.cashierBaseUrl = url
  },
  setCashierMajorVersion(state, version) {
    state.cashierMajorVersion = version
  },
  setBootstrapVersion(state, version) {
    state.bootstrapVersion = version
  },
  setAttributes(state, str) {
    state.attributes = str
  },
  setUserAttributes(state, str) {
    state.userAttributes = str
  }
}

export default mutations
